

module.exports = __webpack_require__.stylable.create(
    "Stats697215594",
    {"classes":{"root":"Stats697215594__root","WarpStats":"Stats697215594__WarpStats","ProfilePosts":"Stats697215594__ProfilePosts"},"vars":{},"stVars":{"DefaultFont":"\"{theme: 'Body-M', size:'16px' }\"","CountersFont":"\"fallback(font(--countersFont), font({theme: 'Body-M', size:'16px' }))\"","HeaderCountersColor":"\"fallback(color(--headerCountersColor), color(color-5))\"","MobileCountersFontSize":"'\"unit(fallback(--m_countersTextSize, 14), px)\"'"},"keyframes":{}},
    "",
    16,
    "Stats697215594",
    null
);
